import { getConfigValue } from '../lib/public-env/get-config-value';
import { getCurrentGatewayUrl } from './environmentDetection';

function normalizeUrlValue(value: string | undefined): string | undefined {
  const trimmedValue = value?.trim();
  if (
    !trimmedValue ||
    trimmedValue.toLowerCase() === 'undefined' ||
    trimmedValue.toLowerCase() === 'null'
  ) {
    return undefined;
  }

  try {
    const normalizedUrl = new URL(trimmedValue).toString();
    return normalizedUrl.replace(/\/$/, '');
  } catch {
    return undefined;
  }
}

function deriveDashboardUrlFromGateway(gatewayUrl: string): string | undefined {
  try {
    const parsedGatewayUrl = new URL(gatewayUrl);

    if (
      parsedGatewayUrl.hostname === 'localhost' ||
      parsedGatewayUrl.hostname === '127.0.0.1'
    ) {
      return 'http://localhost:4200';
    }

    if (parsedGatewayUrl.hostname.startsWith('api.')) {
      const rootDomain = parsedGatewayUrl.hostname.slice('api.'.length);
      return `${parsedGatewayUrl.protocol}//app.${rootDomain}`;
    }

    return undefined;
  } catch {
    return undefined;
  }
}

export function resolveDashboardUrl(): string {
  const configuredDashboardUrl = normalizeUrlValue(
    getConfigValue('NEXT_PUBLIC_TERRA_DASHBOARD_URL'),
  );
  if (configuredDashboardUrl) {
    return configuredDashboardUrl;
  }

  const derivedDashboardUrl = deriveDashboardUrlFromGateway(
    getCurrentGatewayUrl(),
  );
  if (derivedDashboardUrl) {
    return derivedDashboardUrl;
  }

  throw new Error('Unable to resolve dashboard URL for PDF preparation');
}
